<!--
    Every formatting button uses (mousedown)="$event.preventDefault()" to prevent the browser
    from moving focus away from Froala's fr-element when the button is clicked. This keeps the
    active selection intact so formatting commands work correctly. The click event still fires
    normally because preventDefault on mousedown does not suppress click.

    The save button intentionally does NOT use preventDefault — it does not need the selection.
-->
<button
    mat-icon-button
    class="st-story-toolbar__btn"
    [matTooltip]="i18n().PSTStoryEditorToolbarButtonSave"
    [disabled]="disabled() || !hasUnsavedChanges()"
    (click)="onSave()">
    <mat-icon fontSet="material-symbols-outlined">save</mat-icon>
</button>

<button
    mat-icon-button
    class="st-story-toolbar__btn"
    [matTooltip]="i18n().PSTStoryEditorToolbarButtonUndo"
    [disabled]="disabled() || !canUndo()"
    (mousedown)="$event.preventDefault()"
    (click)="onUndo()">
    <mat-icon>undo</mat-icon>
</button>

<button
    mat-icon-button
    class="st-story-toolbar__btn"
    [matTooltip]="i18n().PSTStoryEditorToolbarButtonRedo"
    [disabled]="disabled() || !canRedo()"
    (mousedown)="$event.preventDefault()"
    (click)="onRedo()">
    <mat-icon>redo</mat-icon>
</button>

<button
    mat-icon-button
    class="st-story-toolbar__btn"
    [matTooltip]="i18n().PSTStoryEditorToolbarButtonCopy"
    [disabled]="disabled()"
    (mousedown)="$event.preventDefault()"
    (click)="onCopyText()">
    <mat-icon fontSet="material-symbols-outlined">file_copy</mat-icon>
</button>

<button
    mat-icon-button
    class="st-story-toolbar__btn"
    [matTooltip]="i18n().PSTStoryEditorToolbarButtonCut"
    [disabled]="disabled()"
    (mousedown)="$event.preventDefault()"
    (click)="onCutText()">
    <mat-icon fontSet="material-symbols-outlined">content_cut</mat-icon>
</button>

<button
    mat-icon-button
    class="st-story-toolbar__btn"
    [matTooltip]="i18n().PSTStoryEditorToolbarButtonPaste"
    [disabled]="disabled()"
    (mousedown)="$event.preventDefault()"
    (click)="onPasteText()">
    <mat-icon fontSet="material-symbols-outlined">content_paste</mat-icon>
</button>

<div class="st-story-toolbar__separator"></div>

<button
    mat-icon-button
    class="st-story-toolbar__btn"
    [matTooltip]="i18n().PSTStoryEditorToolbarButtonBold"
    [disabled]="disabled()"
    [class.st-story-toolbar__btn--active]="isBold()"
    (mousedown)="$event.preventDefault()"
    (click)="onFormat('bold')">
    <mat-icon>format_bold</mat-icon>
</button>

<button
    mat-icon-button
    class="st-story-toolbar__btn"
    [matTooltip]="i18n().PSTStoryEditorToolbarButtonItalic"
    [disabled]="disabled()"
    [class.st-story-toolbar__btn--active]="isItalic()"
    (mousedown)="$event.preventDefault()"
    (click)="onFormat('italic')">
    <mat-icon>format_italic</mat-icon>
</button>

<button
    mat-icon-button
    class="st-story-toolbar__btn"
    [matTooltip]="i18n().PSTStoryEditorToolbarButtonUnderline"
    [disabled]="disabled()"
    [class.st-story-toolbar__btn--active]="isUnderline()"
    (mousedown)="$event.preventDefault()"
    (click)="onFormat('underline')">
    <mat-icon>format_underlined</mat-icon>
</button>

<button
    mat-icon-button
    class="st-story-toolbar__btn"
    [matTooltip]="i18n().PSTStoryEditorToolbarButtonStrikethrough"
    [disabled]="disabled()"
    [class.st-story-toolbar__btn--active]="isStrikeThrough()"
    (mousedown)="$event.preventDefault()"
    (click)="onFormat('strikeThrough')">
    <mat-icon>format_strikethrough</mat-icon>
</button>

<div class="st-story-toolbar__separator"></div>

@for (commandType of productionCommandButtons; track commandType) {
    <button
        mat-icon-button
        class="st-story-toolbar__btn"
        [disabled]="disabled()"
        [matTooltip]="getCommandTooltip(commandType)"
        (mousedown)="$event.preventDefault()"
        (click)="onProductionCommand(commandType)">
        <mat-icon [fontSet]="getCommandIconParams(commandType).fontSet">
            {{ getCommandIconParams(commandType).icon }}
        </mat-icon>
    </button>
}
